import {Page, SearchRequestParams} from '../common';

export enum BexioAccountSortField {
    COMPANY_NAME = 'COMPANY_NAME',
    CREATED_AT = 'CREATED_AT',
}

export interface BexioAccountDTO {
    id: number;
    companyName: string;
    token?: string;
    createdAt?: string;
    updatedAt?: string;
    templateSlug?: string;
    bankAccountId?: number;
    taxId?: number;
    userId?: number;
    ownerId?: number;
    contactTypeId?: number;
    french?: number;
    deutsch?: number;
    english?: number;
    stk?: number;
    pc?: number;
    kwh?: number;
    euro?: number;
    chf?: number;
}

export interface PageBexioAccountDTO extends Page {
    content: BexioAccountDTO[];
}

export interface BexioAccountSearchRequestData {
    businessId: number;
    keyword?: string;
    sortField?: BexioAccountSortField;
    sortAsc?: boolean;
}

export interface BexioAccountSearchRequest {
    data: BexioAccountSearchRequestData;
    params?: SearchRequestParams;
}

export interface LinkingBexioAccountRequest {
    businessId: number;
    bexioAccountId: number;
}

export interface SetPrimaryBexioAccountRequest {
    businessId: number;
    bexioAccountId: number;
}

export interface UpdateUserBexioIdRequest {
    businessId: number;
    bexioId?: number;
}